import { FieldData } from '../Pi/types'

export enum StepUnit {
  Second = 1,
  Minute = 60,
  Hour = 60 * 60,
  Day = 60 * 60 * 24,
  Week = 60 * 60 * 24 * 7,
  Month = 60 * 60 * 24 * 30,
}

export enum StepUnitAlias {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
}

export enum TimeUnitInputMode {
  Fixed,
  Converter
}

export type TimeUnitInputData =
  FieldData &
  {
    units?: Array<StepUnit>
    step?: Array<StepUnit>
    min?: number
    max: number
    onUnitChange: (type: StepUnitAlias) => void
    mode: TimeUnitInputMode
    initUnit: StepUnitAlias
    convertFrom: StepUnitAlias
  }
